import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class OverquotaNewAPICall extends APICallV4 {
    _method = 'overquota/new';
    _type: Method = 'post';
}
